import React from 'react';
import '../assets/css/BlogSkeleton.css';

const BlogHeaderSkeleton = () => {
  return (
    <div className="page-banner-area bg-gray2">
      <div className="container mw-1380">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="page-banner-content">
              {/* Breadcrumbs skeleton */}
              <div className="skeleton-breadcrumbs">
                <div className="skeleton-breadcrumb"></div>
                <div className="skeleton-breadcrumb"></div>
                <div className="skeleton-breadcrumb"></div>
              </div>
              
              {/* Title skeleton */}
              <div className="skeleton-page-title"></div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="page-banner-img text-center text-lg-end position-relative z-1">
              {/* Shape skeletons */}
              <div className="skeleton-shape skeleton-shape-1"></div>
              <div className="skeleton-shape skeleton-shape-2"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogHeaderSkeleton;
